import React from 'react';
import { SerializedWidget } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../../common/types';
import { useEditorContext } from '../SMLEditorContext';
import { SMLBlocksTab } from '../blocks/SMLBlocksTab';
import { SMLLookTab } from '../look/SMLLookTab';
import { SMLPageTab } from '../page/SMLPageTab';
import { EditorStatus } from '../topBar/editorStatus';
import { EditorPublish } from '../topBar/useEditorPublish';
import { SMLEditorTabs } from './SMLEditorTabs';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLEditorPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLEditorPanelProps {
  widgets: readonly SerializedWidget[];
  pageWidgets: readonly SerializedWidget[];
  status: EditorStatus;
  publish: EditorPublish;
}

/** The panel with its three tabs (design a1, a5, a6). `?tab=` keeps the tab in the URL. */
const SMLEditorPanelComponent: React.FC<SMLEditorPanelProps> = ({ widgets, pageWidgets, status, publish }) => {
  const { url } = useEditorContext();
  return (
    <div className={styles.panel}>
      <SMLEditorTabs tab={url.tab} blockCount={widgets.length} onSelect={url.setTab} />
      <div className={styles.body} role="tabpanel">
        {url.tab === 'blocks' && <SMLBlocksTab widgets={widgets} pageWidgets={pageWidgets} />}
        {url.tab === 'look' && <SMLLookTab />}
        {url.tab === 'page' && <SMLPageTab status={status} publish={publish} blockCount={widgets.length} />}
      </div>
    </div>
  );
};

export const SMLEditorPanel = TypedMemo(SMLEditorPanelComponent);
